import PropTypes from 'prop-types';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoginLoading = ({
  message
}) => /*#__PURE__*/_jsxs("div", {
  className: "login-loading",
  children: [/*#__PURE__*/_jsx(UILoadingSpinner, {
    grow: true,
    minHeight: 100
  }), /*#__PURE__*/_jsx("h1", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `login.loading.${message}`
    })
  })]
});
LoginLoading.propTypes = {
  message: PropTypes.string
};
LoginLoading.defaultProps = {
  message: 'default'
};
export default LoginLoading;